export const recordingMessages = {
  tw: {
    ersRecording: {
      start: '開始錄音',
      stop: '停止錄音',
      cancel: '取消',
      cancelPreparing: '取消啟用麥克風',
      cancelConnecting: '取消連線',
      unavailable: '目前沒有可用的點數',
      preparing: '正在啟用麥克風，請允許瀏覽器存取。',
      connecting: '正在連接語音服務…',
      recording: '正在錄音；說完後可點麥克風停止，或等候約 3 秒自動停止。',
      finishing: '正在完成語音辨識與評分，請稍候…',
      complete: '辨識完成，確認文字後再送出。',
      errors: {
        NotAllowedError: '請允許瀏覽器存取麥克風，再重新錄音。',
        NotFoundError: '未偵測到麥克風，請確認裝置已連接。',
        NotReadableError: '麥克風無法使用，請關閉其他使用麥克風的程式後重試。',
        SecurityError: '請使用 HTTPS 或 localhost 開啟錄音功能。',
        UNSUPPORTED_BROWSER: '此瀏覽器不支援這個錄音方式，請改用一般錄音或更新瀏覽器。',
        UNSUPPORTED_LANGUAGE: '此語言不支援即時評分，請改用一般錄音。',
        BAD_TOKEN: '評分連線憑證無效，請重新開始錄音。',
        BAD_SIGNATURE: '評分連線憑證無效，請重新開始錄音。',
        EXPIRED: '評分連線憑證已過期，請重新開始錄音。',
        AUTH_REQUIRED: '請先登入，再使用即時評分。',
        TIMEOUT: '評分等待逾時，請重新開始錄音。',
        CONNECTION_CLOSED: '評分連線中斷，請重新錄音；這次錄音無法續傳。',
        NETWORK_SLOW: '網路傳送速度不足，請確認連線後重新錄音。',
        AZURE_ERROR: '語音評分服務暫時無法使用，請稍後重試。',
        SAVE_FAILED: '評分完成但儲存失敗，請重新錄音提交。',
        FFMPEG_FAILED: '音訊處理失敗，請重新錄音。',
        BAD_MESSAGE: '評分訊息格式有誤，請重新操作。',
        EMPTY_AUDIO: '沒有收到錄音內容，請確認麥克風後重試。',
        NO_SPEECH: '沒有辨識到語音，請靠近麥克風重新錄音。',
        ERS_RESULT_INVALID: '語音辨識結果或錄音編號不完整，請重新錄音。',
        MICROPHONE_ENDED: '麥克風已中斷，請確認裝置後重新錄音。',
        TOKEN_UNAVAILABLE: '目前無法建立即時評分連線，請稍後重試或改用一般錄音。',
        DEFAULT: '錄音失敗，請確認麥克風與網路後重試。'
      }
    }
  },
  en: {
    ersRecording: {
      start: 'Start recording',
      stop: 'Stop recording',
      cancel: 'Cancel',
      cancelPreparing: 'Cancel microphone setup',
      cancelConnecting: 'Cancel connection',
      unavailable: 'No speaking points available',
      preparing: 'Enabling your microphone. Please allow microphone access.',
      connecting: 'Connecting to the speech service…',
      recording: 'Recording. Tap the microphone to stop, or pause for about 3 seconds after speaking.',
      finishing: 'Finishing speech recognition and assessment…',
      complete: 'Recognition complete. Review the text before sending.',
      errors: {
        NotAllowedError: 'Allow microphone access, then try again.',
        NotFoundError: 'No microphone was found. Check your device.',
        NotReadableError: 'Your microphone is unavailable. Close other recording apps and retry.',
        SecurityError: 'Open this page using HTTPS or localhost.',
        UNSUPPORTED_BROWSER: 'This browser does not support streaming recording. Update your browser.',
        UNSUPPORTED_LANGUAGE: 'This language does not support streaming assessment.',
        BAD_TOKEN: 'The speech session token is invalid. Start a new recording.',
        BAD_SIGNATURE: 'The speech session token is invalid. Start a new recording.',
        EXPIRED: 'The speech session token has expired. Start a new recording.',
        AUTH_REQUIRED: 'Sign in before using speech assessment.',
        TIMEOUT: 'Speech assessment timed out. Start a new recording.',
        CONNECTION_CLOSED: 'The connection was lost. This recording cannot resume; please record again.',
        NETWORK_SLOW: 'Your connection is too slow. Check your network and record again.',
        AZURE_ERROR: 'Speech assessment is temporarily unavailable. Please try again later.',
        SAVE_FAILED: 'Assessment finished, but saving failed. Please record again.',
        FFMPEG_FAILED: 'Audio processing failed. Please record again.',
        BAD_MESSAGE: 'Invalid speech service message. Please try again.',
        EMPTY_AUDIO: 'No audio was received. Check your microphone and try again.',
        NO_SPEECH: 'No speech was recognized. Move closer to your microphone and try again.',
        ERS_RESULT_INVALID: 'The transcript or recording ID is incomplete. Please record again.',
        MICROPHONE_ENDED: 'The microphone disconnected. Check your device and record again.',
        TOKEN_UNAVAILABLE: 'Unable to connect to speech assessment. Please try again later.',
        DEFAULT: 'Recording failed. Check your microphone and network, then try again.'
      }
    }
  },
  cn: {
    ersRecording: {
      start: '开始录音',
      stop: '停止录音',
      cancel: '取消',
      cancelPreparing: '取消启用麦克风',
      cancelConnecting: '取消连线',
      unavailable: '目前没有可用的点数',
      preparing: '正在启用麦克风，请允许浏览器存取。',
      connecting: '正在连接语音服务…',
      recording: '正在录音；说完后可点麦克风停止，或等候约 3 秒自动停止。',
      finishing: '正在完成语音辨识与评分，请稍候…',
      complete: '辨识完成，确认文字后再送出。',
      errors: {
        NotAllowedError: '请允许浏览器存取麦克风，再重新录音。',
        NotFoundError: '未侦测到麦克风，请确认装置已连接。',
        NotReadableError: '麦克风无法使用，请关闭其他使用麦克风的程式后重试。',
        SecurityError: '请使用 HTTPS 或 localhost 开启录音功能。',
        UNSUPPORTED_BROWSER: '此浏览器不支援这个录音方式，请改用一般录音或更新浏览器。',
        UNSUPPORTED_LANGUAGE: '此语言不支援即时评分，请改用一般录音。',
        BAD_TOKEN: '评分连线凭证无效，请重新开始录音。',
        BAD_SIGNATURE: '评分连线凭证无效，请重新开始录音。',
        EXPIRED: '评分连线凭证已过期，请重新开始录音。',
        AUTH_REQUIRED: '请先登入，再使用即时评分。',
        TIMEOUT: '评分等待逾时，请重新开始录音。',
        CONNECTION_CLOSED: '评分连线中断，请重新录音；这次录音无法续传。',
        NETWORK_SLOW: '网路传送速度不足，请确认连线后重新录音。',
        AZURE_ERROR: '语音评分服务暂时无法使用，请稍后重试。',
        SAVE_FAILED: '评分完成但储存失败，请重新录音提交。',
        FFMPEG_FAILED: '音讯处理失败，请重新录音。',
        BAD_MESSAGE: '评分讯息格式有误，请重新操作。',
        EMPTY_AUDIO: '没有收到录音内容，请确认麦克风后重试。',
        NO_SPEECH: '没有辨识到语音，请靠近麦克风重新录音。',
        ERS_RESULT_INVALID: '语音辨识结果或录音编号不完整，请重新录音。',
        MICROPHONE_ENDED: '麦克风已中断，请确认装置后重新录音。',
        TOKEN_UNAVAILABLE: '目前无法建立即时评分连线，请稍后重试或改用一般录音。',
        DEFAULT: '录音失败，请确认麦克风与网路后重试。'
      }
    }
  }
}
